import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";


export function CustomersLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.customers.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
